import type { PageThemeDefinition } from "../types";

export const amberTheme: PageThemeDefinition = {
  id: "amber",
  labelKey: "robot.setting.page_theme.amber",
  preview: {
    background: "#1A1408",
    cardBg: "#241C0E",
    text: "#ffffff",
  },
  tokens: {
    background: "#1A1408",
    cardBg: "#241C0E",
    text: "#ffffff",
    textSecondary: "#D4C4A0",
    border: "#4A3A1A",
    headerBg: "#1A1408",
    inputBg: "#241C0E",
    messageBg: "#241C0E",
    senderBg: "#241C0E",
    statusOnline: "#02BA54",
    statusEnding: "#ED645F",
    starActive: "#FFE200",
    starInactive: "#5a4a30",
    shadow: "rgba(0, 0, 0, 0.5)",
    hoverBg: "#2E2414",
    accent: "#F39C12",
    appearance: "dark",
    chatMessageText: "#FFFFFF",
    chatAgentBubbleBg: "#322814",
    chatAgentBubbleBorder: "#4A3A1A",
    chatUserGradientStart: "#E67E22",
    chatUserGradientEnd: "#B35A0E",
    chatUserMessageText: "#FFFFFF",
    chatInputFieldBg: "#1A1408",
    chatInputText: "#FFFFFF",
    chatInputPlaceholder: "#D4C4A0",
    chatMediaBg: "#1A1408",
    chatIconColor: "#FFFFFF",
    chatLinkColor: "#F5B041",
  },
};
